<template>
  <div>
    <div class="stepContent">
      <el-row>
        <el-col :span="24" class="box-card-content-edit" v-loading="isLoading">
          <el-form ref="courseDataModel" :model="courseDataModel" label-width="150px" label-position="right">
            <el-form-item label="报名课程:">
              <el-col :span="10">
                <span v-if="isCompleted">{{ courseDataModel.courseName }}</span>
                <el-select v-else v-model="courseDataModel.courseId" placeholder="请选择课程" @change="onCourseChange">
                  <el-option v-for="(item, index) in studentCourseList" :key="index" :label="item.Name"
                    :value="item.Id"></el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="课程周:">
              <span v-if="isCompleted">{{ courseDataModel.courseWeekString }}</span>
              <avappCourseWeek v-show="!!courseDataModel.courseId && !isCompleted" :dataIn="courseWeekData"
                @selectWeek="onSelectWeek"></avappCourseWeek>
            </el-form-item>
            <el-form-item label="报课情况:" v-if="checkWorkflowCourseStatusResult.hasError">
              <div>
                <span
                  :class="{ 'normal-sign-color': !checkWorkflowCourseStatusResult.hasError, 'nonormal-sign-color': checkWorkflowCourseStatusResult.hasError }">{{ checkWorkflowCourseStatusResult.errorMessage }}</span>
              </div>
            </el-form-item>
            <el-form-item label="签到情况:">
              <div v-if="hasSelectedSignIn">
                <span
                  :class="{ 'normal-sign-color': isFreeVideo, 'nonormal-sign-color': !isFreeVideo }">{{ signDetailModel.signInTypeText }}</span>
                <span class="special-reason-description" v-if="!isFreeVideo && !dataIn.isFreeForAll">
                  <br>若有特殊原因需要免费观看视频，请提交特殊申请由管理员审核</span>
                <br>
              </div>
              <div v-else>
                <br>
              </div>
              <div>
                <span class="cs-redLabel">每个课节可观看总时长为每一节直播课程时长的倍数({{dataIn.studentVideoDurationText}})，请同学确认预约课节是否正确。</span>
              </div>
            </el-form-item>
            <el-form-item label="学期免费:" v-if="courseDataModel.isUseTermFreeCount">
              <span>剩余次数({{ freeWatchCount }}),当前使用1次</span>
            </el-form-item>

            <!-- <el-form-item label="" v-show="hasSelectedSignIn && !!courseDataModel.courseId && hasOwnDevice">
              <el-col :span="10">
                <span v-if="isCompleted">{{ ownDeviceName }}</span>
                <el-checkbox v-else v-model="courseDataModel.isOwnDevice" class="input-width" @change="onIsOwnDeviceChange">{{ownDeviceName}}</el-checkbox>
              </el-col>
            </el-form-item>

            <el-form-item label="预约时长" v-show="hasSelectedSignIn && !!courseDataModel.courseId">
              <el-col :span="10">
                <span v-if="isCompleted">{{ minutesText }}</span>
                <el-select v-else :disabled="courseDataModel.isOwnDevice" v-model="courseDataModel.minutes" placeholder="请选择课程">
                  <el-option v-for="(item, index) in timeLengthList" :key="index" :label="item.name"
                    :value="item.value"></el-option>
                </el-select>
              </el-col>
            </el-form-item> -->

            <!-- <el-form-item label="是否只观看1小时视频:">
              <el-col :span="1">
                <span v-if="isCompleted">{{courseDataModel.isOneHour ? "是" : "否"}}</span>
                <el-checkbox v-else v-model="courseDataModel.isOneHour" @change="onOneHourChange"></el-checkbox>
              </el-col>
              <span class="">
              (注意：如果迟到或者早退，可选择只观看一小时视频，视频播放时长仅为<strong class="import-message">一小时</strong>）</span>
            </el-form-item> -->
            <el-form-item label="价格: " v-if="!dataIn.isFreeForAll">
              <div v-if="hasSelectedSignIn">
                <span v-if="isFreeVideo || courseDataModel.applicationType == 1">免费回看(押金: C$
                  {{ depositPrice }})，为防止同学浪费校区电脑资源，当按照预约时间准时观看视频后押金会自动退还。</span>
                <!-- <span v-else-if="courseDataModel.applicationType == 1">押金 C$ {{ courseDataModel.price }}</span> -->
                <span v-else>C$ {{ courseDataModel.price }}</span>

              </div>
            </el-form-item>
            <div v-show="hasSelectedSignIn && !isFreeVideo && !dataIn.isFreeForAll && !courseDataModel.isUseTermFreeCount">
              <el-form-item label="特殊申请: ">
                <el-col :span="10">
                  <span v-if="isCompleted">{{ courseDataModel.applicationTypeText }}</span>
                  <el-select v-else v-model="courseDataModel.applicationType" @change="onApplicationTypeChange">
                    <el-option v-for="(item, index) in applicationTypeList" :key="index" :label="item.Value"
                      :value="item.Key"></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </div>
            <el-form-item
              v-if="hasSelectedSignIn && !isFreeVideo && !dataIn.isFreeForAll && courseDataModel.applicationType == 1"
              label="申请内容: ">
              <el-row>
                <el-col :span="16">
                  <span v-if="isCompleted">{{ courseDataModel.applicationDescription }}</span>
                  <el-input v-else type="textarea" :rows="6"
                    placeholder="必填*请填写特殊原因详情。 如因系统技术问题无法正常签到，或者因大学不得已的冲突情况而旷课， 凡是非速成原因或大学特殊原因，都将不满足免费观看条件。请带上证明前往速成前台进行审核"
                    v-model="courseDataModel.applicationDescription" @change="appDescriptionChange"></el-input>
                </el-col>
                <el-col v-for="(item, index) in courseDataModel.fileList" :key="index">
                  <a :href="item.FilePath + sasKey" type="text" target="_blank">{{ item.FileName }}</a>&nbsp;&nbsp;
                  <el-button v-if="!isCompleted" size="medium" type="text" icon="el-icon-delete" class="delete-button"
                    @click="removeFile(item, index)">删除</el-button>
                </el-col>
                <el-col>
                  <el-button v-if="!isCompleted" type="primary" plain icon="el-icon-upload"
                    @click="uploadSpecialApplicationFile">上传文件</el-button>
                </el-col>
              </el-row>
            </el-form-item>
            <el-dialog center title="上传特殊申请证明" :show-close="true" :close-on-click-modal="false" width="700px"
              :visible.sync="specialFileUploaderVisible" top="8vh">
              <blob-uploader @closeEditor="onCloseFileUploader" @blobUploadError="onFileUploadError"
                @blobUploaded="onFileUploaded" :isAutoSave="true" :type="6" :accepts="'.png,.jpg,.jpeg,.pdf,.doc,.docx'"
                :isVisible="specialFileUploaderVisible"></blob-uploader>
            </el-dialog>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style>
.normal-sign-color {
  color: #35b12b;
}

.nonormal-sign-color {
  color: #c0272d;
}

.special-reason-description {
  font-size: 10px;
  color: #b5b5b5;
}

.import-message {
  font-size: 1.2em;
  font-weight: bold;
  color: red;
}
</style>

<script>
import avappCourseWeek from "./avappCourseWeek";
import blobUploader from "../fileHandler/blobUploader";
import { getSharedAccessSignature } from "../../service/blobStorage.service";
import {formatMinutes} from "../../config/mUtils"; 
import {
  getVideoAppointmentApplicationType,
  //getVideoAppointmentPrice,
  //getVideoAppointmentDepositPrice
} from "../../service/videoAppointment.service";
import { checkWorkflowCourseStatus } from "@/service/course.service"
let moment = require("moment");

export default {
  props: {
    isCompleted: Boolean,
    dataIn: {
      isFreeForAll: Boolean,
      studentCourseList: Array,
      model: Object,
      priceData: Object,
      studentVideoDurationText: String
    }
  },
  components: {
    avappCourseWeek,
    blobUploader
  },
  data() {
    return {
      isLoading: true,
      sasKey: "",
      //isNormalSignIn: true,
      isFreeVideo: false,
      hasSelectedSignIn: false,
      checkWorkflowCourseStatusResult: {
        hasError: false,
        errorMessage: ""
      },
      signDetailModel: {
        signInType: 0,
        signInTypeText: ""
      },
      courseDataModel: {
        courseId: "",
        courseName: "",
        courseActivationId: 0,
        courseMinutes: 0,
        courseWeek: 0,
        courseWeekString: "",
        availableMinutes: 0,
        applicationType: 0,
        applicationTypeText: "",
        applicationDescription: "",
        isFree: false,
        isOneHour: false,
        price: 0,
        fileList: [],
        isOwnDevice: false,
        minutes: 0,
      },
      courseWeekData: {
        courseId: 0,
        courseActivationId: 0,
        isReviewCourse: false,
        isOwnDevice: false,
      },
      doublePriceMinutes: 300,
      studentCourseList: [],
      applicationTypeList: [],
      supplementVideoPrice: 0, //看视频价格
      depositPrice: 0, //定金价格
      specialFileUploaderVisible: false,
      ownDeviceName: "自带电脑/平板和耳机",
      timeLengthList:[],
      minuteScale: 30,
      minutesText: "",
      hasOwnDevice: true,
      freeWatchCount: 0
    };
  },
  created() {
    getSharedAccessSignature(true)
      .then(result => {
        if (!!result && result.success) {
          this.sasKey = result.data;
        }
      })
      .catch(err => { });
    this.initData();
  },
  mounted() { },
  methods: {
    init() {
      this.isLoading = true;
      if (!!this.dataIn) {
        this.studentCourseList = this.dataIn.studentCourseList;
        this.courseDataModel = this.dataIn.model;
        this.supplementVideoPrice = this.dataIn.priceData.supplementVideoPrice;
        this.depositPrice = this.dataIn.priceData.depositPrice;
        if (!!this.courseDataModel.courseId) {
          this.loadCourse(this.courseDataModel.courseActivationId);
        }
        
        //this.getMinutesText();
      } else {
        this.courseDataModel = {
          courseId: "",
          courseName: "",
          courseActivationId: 0,
          courseMinutes: 0,
          courseWeek: 0,
          courseWeekString: "",
          availableMinutes: 0,
          applicationType: "",
          applicationTypeText: "",
          applicationDescription: "",
          isFree: false,
          price: 0,
          fileList: [],
          isOwnDevice: false,
          minutes: 0,
          isUseTermFreeCount: false
        };
        this.courseWeekData = {
          courseId: 0,
          courseActivationId: 0,
          isReviewCourse: false
        };
      }
      this.isLoading = false;
    },
    initData() {
      //this.loadStudentCourseList();
      this.loadVAApplicationType();
      //this.loadVASupplementPrice();
      //this.loadVideoAppointmentDepositPrice();
    },
    onSelectWeek(row, isChecked) {
      if (isChecked) {
        this.hasSelectedSignIn = isChecked;
        this.setCourseSignDetail(row, isChecked);
      }
    },
    loadVAApplicationType() {
      getVideoAppointmentApplicationType().then(result => {
        if (!!result && result.success) {
          this.applicationTypeList = result.data;
        }
      });
    },
    // loadVASupplementPrice() {
    //   getVideoAppointmentPrice().then(result => {
    //     if (!!result && result.success) {
    //       this.supplementVideoPrice = result.data;
    //     }
    //   });
    // },
    // loadVideoAppointmentDepositPrice() {
    //   //获取定金价格
    //   getVideoAppointmentDepositPrice().then(result => {
    //     if (result && result.success) {
    //       this.videoAppointmentDepositPrice = result.data;
    //     }

    //   })
    // },
    onCourseChange() {
      this.loadCourse();
      this.checkEWCourseStatus();
      this.courseDataModel.courseActivationId = 0;
    },
    loadCourse(courseActivationId) {
      this.hasSelectedSignIn = false;
      this.freeWatchCount = 0;
      let course = this.studentCourseList.find(
        i => i.Id == this.courseDataModel.courseId
      );
      let isReviewCourse = false;
      if (!!course) {
        this.courseDataModel.courseName = course.Name;
        isReviewCourse = course.IsReviewCourse;
        this.freeWatchCount = course.FreeWatchCount;
        // this.hasOwnDevice = course.HasOwnDevice;
        // if (!this.hasOwnDevice){
        //   this.courseDataModel.isOwnDevice = false;
        // }
      }
      if (typeof courseActivationId == "undefined") {
        courseActivationId = 0;
      }

      this.courseWeekData = {
        courseId: this.courseDataModel.courseId,
        courseActivationId: courseActivationId,
        isReviewCourse: isReviewCourse
      };
    },
    async checkEWCourseStatus() {
      let courseId = this.courseWeekData.courseId;
      let result = await checkWorkflowCourseStatus(courseId);
      if (!result)
        return;

      if (result.success) {
        this.checkWorkflowCourseStatusResult.hasError = false;
        this.checkWorkflowCourseStatusResult.errorMessage = "";
      } else {
        this.checkWorkflowCourseStatusResult.hasError = true;
        this.checkWorkflowCourseStatusResult.errorMessage = result.message;
      }
    },
    setCourseSignDetail(signDetail, isChecked) {
      this.courseDataModel.courseActivationId = signDetail.CourseActivationId;
      this.courseDataModel.courseWeek = signDetail.Week;
      this.courseDataModel.courseWeekString = signDetail.WeekFullText;
      this.courseDataModel.availableMinutes = signDetail.AvailableMinutes;
      this.courseDataModel.date = signDetail.DateText;
      this.signDetailModel.signInType = signDetail.SignInType;
      this.signDetailModel.signInTypeText = signDetail.SignInTypeText;
      this.courseDataModel.courseMinutes = signDetail.Minutes;
      
      this.isFreeVideo = signDetail.IsFree;
      this.setVideoPrice();
    },
    setVideoPrice() {
      if (this.dataIn.isFreeForAll){
        //视频预约免费
        this.courseDataModel.price = 0;
        this.courseDataModel.isFree = true;
      }else{
        let isDepositPrice = true;
        if (!this.isFreeVideo && this.courseDataModel.applicationType !== 1) {
          if (this.freeWatchCount > 0){
            this.courseDataModel.isUseTermFreeCount = true;
          }else{
            isDepositPrice = false;
          }
        }
        if (isDepositPrice){
          this.courseDataModel.price = this.depositPrice;
          this.courseDataModel.isFree = true;
        }else{
          this.courseDataModel.isFree = false;
          this.courseDataModel.price = this.supplementVideoPrice;
        }
      }
    },
    onOneHourChange() {
      this.setVideoPrice();
    },
    onApplicationTypeChange() {
      this.setVideoPrice();
    },
    appDescriptionChange() { },
    uploadSpecialApplicationFile() {
      this.specialFileUploaderVisible = true;
    },
    onCloseFileUploader() {
      this.closeFileUploader();
    },
    onFileUploadError() { },
    closeFileUploader() {
      this.specialFileUploaderVisible = false;
    },
    onFileUploaded(data) {
      if (!!data) {
        this.closeFileUploader();
        let fileModel = {
          Id: 0,
          FileId: data.FileId,
          FileName: data.FileName,
          FilePath: data.Path,
          DateText: moment().format("L")
        };
        this.courseDataModel.fileList.push(fileModel);
      } else {
        this.closeFileUploader();
      }
    },
    removeFile(item, index) {
      this.$confirm("您确定要删除该文件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.courseDataModel.fileList.splice(index, 1);
        })
        .catch(() => { });
    },
    valid() {
      let isValid = true;
      let message = "";

      if (!this.courseDataModel.courseId) {
        isValid = false;
        message = "请选择课程";
      }

      if (isValid && !this.courseDataModel.courseActivationId) {
        isValid = false;
        message = "请选择课程周";
      }

      if (isValid && this.checkWorkflowCourseStatusResult.hasError) {
        isValid = false;
        message = this.checkWorkflowCourseStatusResult.errorMessage;
      }

      if (isValid && this.courseDataModel.availableMinutes < this.minuteScale) {
        isValid = false;
        message = `可观看时长不足，剩余${this.courseDataModel.availableMinutes}分钟`;
      }

      if (isValid && !this.isFreeVideo) {
        switch (this.courseDataModel.applicationType) {
          case 0:
            isValid = true;
            break;
          case 1:
            if (!this.courseDataModel.applicationDescription && this.courseDataModel.fileList.length == 0) {
              if (!this.courseDataModel.applicationDescription) {
                message = "请输入申请原因";
              }
              if (this.courseDataModel.fileList.length == 0) {
                if (!!message) {
                  message += ", ";
                }
                message += "请上传申请证明文件";
              }
              isValid = false;
            } else {
              isValid = true;
            }
            break;
        }
      }

      if (!!message) {
        this.$message.warning(message);
      }
      return isValid;
    },
    getData() { },
  },
  watch: {
    dataIn: function () {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addVideoAppointment/avappWorkflowStep1.vue